(function(){
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];
  // Currency helper set by theme.liquid before including this file
  var CURRENCY = window.__SHOP_CURRENCY || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';

  // Hook checkout buttons (begin_checkout)
  function hookCheckoutButtons(){
    var selectors = [
      'form[action="/cart"] [name="checkout"]',
      'button[name="checkout"]',
      'a[href*="/checkout"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el){
      if (el.__gtmHooked) return;
      el.__gtmHooked = true;
      el.addEventListener('click', function(){
        try{
          window.dataLayer.push({event:'begin_checkout'});
        }catch(e){}
      }, {capture:true});
    });
  }
  hookCheckoutButtons();
  new MutationObserver(hookCheckoutButtons).observe(document.documentElement, {childList:true, subtree:true});

  // Intercept fetch for add_to_cart events
  var _fetch = window.fetch;
  if (typeof _fetch === 'function'){
    window.fetch = function(resource, init){
      var p = _fetch(resource, init);
      try {
        var url = (typeof resource === 'string') ? resource : (resource && resource.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          p.then(function(resp){
            try {
              resp.clone().text().then(function(text){
                try{
                  var data = {};
                  try{ data = JSON.parse(text); }catch(_){}
                  // Shopify /cart/add.js returns either single item or the whole cart depending on theme; handle single
                  var item = (data && (data.item || data)) || {};
                  if (item && (item.id || item.variant_id || item.product_id)) {
                    var price = (item.price != null ? item.price : item.final_price);
                    var qty = item.quantity || 1;
                    window.dataLayer.push({
                      event: 'add_to_cart',
                      ecommerce: {
                        currency: CURRENCY,
                        value: price != null ? (price/100) * qty : undefined,
                        items: [{
                          item_id: String(item.product_id || item.id || ''),
                          item_variant: String(item.variant_id || item.id || ''),
                          item_name: item.title || document.title,
                          price: price != null ? price/100 : undefined,
                          quantity: qty
                        }]
                      }
                    });
                  }
                }catch(e){}
              });
            }catch(e){}
          });
        }
      } catch(e){}
      return p;
    };
  }

  // Fallback: Intercept form POST /cart/add (non-AJAX themes)
  document.addEventListener('submit', function(ev){
    try{
      var form = ev.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(action)) {
        var qty = parseInt((form.querySelector('[name="quantity"]')||{}).value || '1', 10);
        window.dataLayer.push({event:'add_to_cart', ecommerce:{currency:CURRENCY, items:[{quantity: qty}]}});
      }
    }catch(e){}
  }, true);
})();